import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import TableData from "../../components/TableData";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps } from "../../redux/miniCrm/vnpost";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
  },
  formControlLabel: {
    margin: 0,
  },
});

class Stages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalAction: false,
      modalDelete: false,
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getListPostOffice();
  }

  listCollumns = [
    { id: "code", numeric: true, disablePadding: false, label: "Mã bưu phẩm" },
    {
      id: "postOffice",
      numeric: true,
      disablePadding: false,
      label: "Bưu cục",
    },
    {
      id: "postmanTel",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại bưu tá",
    },
    {
      id: "receiverTel",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại người nhận",
    },
    { id: "status", numeric: true, disablePadding: false, label: "Trạng thái" },
    {
      id: "deliveryStatus",
      numeric: true,
      disablePadding: false,
      label: "Trạng thái phát",
    },
    { id: "view", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit = () => {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "code":
            case "postmanTel":
            case "receiverTel":
            case "deliveryStatus":
            case "status":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.countListPackage({ where: where });
    this.props.getListPackage(filters.order, filters.pageSize, filters.page, {
      where,
    });
  };

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    filters.page = page * filters.pageSize;
    this.setState({ page, filters });
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleChange = (e) => {
    // console.log(e);
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = name === "code" ? value : { like: value };
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };
  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {} });
  };

  handleAction = () => {
    const { id } = this.state.item;
    if (!id) {
      const {
        id,
        code,
        description,
        poId,
        postmanTel,
        receiverTel,
        deliveryStatus,
        status,
      } = this.state;
      return (
        this.props.addNewPackage(
          code,
          description,
          poId,
          postmanTel,
          receiverTel,
          deliveryStatus,
          status
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      const {
        id,
        code,
        description,
        poId,
        postmanTel,
        receiverTel,
        deliveryStatus,
        status,
      } = this.state.item;
      return (
        this.props.editPackage(
          id,
          code,
          description,
          poId,
          postmanTel,
          receiverTel,
          deliveryStatus,
          status
        ),
        setTimeout(
          function () {
            this.setState({ modalAction: false });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deletePackage(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleClickColor = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleCloseColor = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChangeColor = (color) => {
    this.setState({ color: color.hex });
  };
  handleChangeColorEdit = (color) => {
    this.setState({
      item: {
        ...this.state.item,
        color: color.hex,
      },
    });
  };

  render() {
    const { classes, listPackage, countPackage, listPostOffice } = this.props;
    const {
      id,
      code,
      description,
      poId,
      postmanTel,
      receiverTel,
      deliveryStatus,
      status,
      filters,
      item,
      modalDelete,
      modalAction,
    } = this.state;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item md={3} sm={12}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Mã bưu phẩm"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.code}
                        name="code"
                      />
                    </Grid>
                    <Grid item md={3} sm={12}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Số điện thoại bưu tá"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.postmanTel
                            ? filters.where.postmanTel.like
                            : ""
                        }
                        name="postmanTel"
                        type="number"
                      />
                    </Grid>
                    <Grid item md={3} sm={12}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Số điện thoại người nhận"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.receiverTel
                            ? filters.where.receiverTel.like
                            : ""
                        }
                        name="receiverTel"
                        type="number"
                      />
                    </Grid>
                    <Grid item md={3} sm={12}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          variant="contained"
                          color="primary"
                          aria-label="Search"
                          type="submit"
                          className={classes.fab}>
                          <Search />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách bưu gửi"
          items={listPackage}
          rowsPerPage={filters.pageSize}
          count={countPackage ? countPackage.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleView={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={modalAction}
          title={
            item ? (item.id ? "Chỉnh sửa thông tin" : "Thêm thông tin") : null
          }
          maxWidth={false}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <Grid item md={6} sm={12} style={{ padding: 5 }}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Mã bưu phẩm"
                      variant="outlined"
                      className={classes.input}
                      autoFocus={true}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("code")
                            : this.handleChangeText("code")
                          : null
                      }
                      value={item ? (item.id ? item.code : code) : null}
                      name="code"
                      validators={["required"]}
                      errorMessages={[`Không được để trống`]}
                    />
                    <SelectValidator
                      id="outlined-full-width"
                      margin="normal"
                      select
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                          shrink: true,
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Bưu cục"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("poId")
                            : this.handleChangeText("poId")
                          : null
                      }
                      value={item ? (item.id ? item.poId : poId) : null}
                      name="poId"
                      validators={["required"]}
                      errorMessages={[`Không được để trống`]}>
                      {listPostOffice
                        ? listPostOffice.map((i, key) => {
                            return (
                              <MenuItem key={key} value={i.id}>
                                {i.id} - {i.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </SelectValidator>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Số điện thoại bưu tá"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("postmanTel")
                            : this.handleChangeText("postmanTel")
                          : null
                      }
                      value={
                        item ? (item.id ? item.postmanTel : postmanTel) : null
                      }
                      name="postmanTel"
                      validators={["required"]}
                      errorMessages={[`Không được để trống`]}
                      type="number"
                    />
                  </Grid>
                  <Grid item md={6} sm={12} style={{ padding: 5 }}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Số điện thoại người nhận"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("receiverTel")
                            : this.handleChangeText("receiverTel")
                          : null
                      }
                      value={
                        item ? (item.id ? item.receiverTel : receiverTel) : null
                      }
                      name="receiverTel"
                      validators={["required"]}
                      errorMessages={[`Không được để trống`]}
                      type="number"
                    />
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Trạng thái phát"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("deliveryStatus")
                            : this.handleChangeText("deliveryStatus")
                          : null
                      }
                      value={
                        item
                          ? item.id
                            ? item.deliveryStatus
                            : deliveryStatus
                          : null
                      }
                      name="deliveryStatus"
                      validators={["required"]}
                      errorMessages={[`Không được để trống`]}
                    />
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Trạng thái"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("status")
                            : this.handleChangeText("status")
                          : null
                      }
                      value={item ? (item.id ? item.status : status) : null}
                      name="status"
                      validators={["required"]}
                      errorMessages={[`Không được để trống`]}
                    />
                  </Grid>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Mô tả"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("description")
                          : this.handleChangeText("description")
                        : null
                    }
                    value={
                      item ? (item.id ? item.description : description) : null
                    }
                    name="description"
                    multiline
                    rows={3}
                  />
                </Grid>
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                {item ? (
                  !item.id ? (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}>
                      Lưu
                    </Button>
                  ) : null
                ) : null}
              </DialogActions>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

Stages.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listPackage: state.vnpost.packages,
  listPostOffice: state.vnpost.postOffice,
  countPackage: state.vnpost.count,
});

Stages = connect(mapStateToProps, mapActionsToProps)(Stages);

export default withStyles(styles)(Stages);
